export const INVOICES_FILTER_KEY_SEARCH = 'searchString';
export const INVOICES_FILTER_KEY_BILLING_PERIOD = 'billingPeriod';
export const INVOICES_FILTER_KEY_STATUS = 'status';
export const INVOICES_FILTER_KEY_PROJECT = 'project';
export const INVOICES_FILTER_KEY_CLIENT = 'client';
export const INVOICES_FILTER_KEY_BILLING_MODEL = 'billingModel';

export const INVOICES_TABLE_FILTER_KEYS = [
  INVOICES_FILTER_KEY_SEARCH,
  INVOICES_FILTER_KEY_BILLING_PERIOD,
  INVOICES_FILTER_KEY_STATUS,
  INVOICES_FILTER_KEY_PROJECT,
  INVOICES_FILTER_KEY_CLIENT,
  INVOICES_FILTER_KEY_BILLING_MODEL,
];

export const INVOICES_TABLE_FILTERS_STORAGE_KEY = 'invoices-table-filters';

export const GENERATE_INVOICES_TABLE_FILTERS_STORAGE_KEY = 'generate-invoices-table-filters';
